import { RubArtifactCommand } from "../../core/commands/RubArtifactCommand";
import { getComponent } from "../../world/Entity";
import type { Interaction, InteractionContext } from "../Interaction";
import type { ArtifactComponent, EntityComponent } from "../../world/components";

function artifactOf(ctx: InteractionContext): ArtifactComponent | undefined {
  if (ctx.entity) return getComponent(ctx.entity, "artifact");
  if (ctx.inventoryItem) {
    const components = (ctx.inventoryItem.metadata as { components?: readonly EntityComponent[] } | undefined)?.components;
    return components?.find((c): c is ArtifactComponent => c.type === "artifact");
  }
  return undefined;
}

/** Rub or clean a tarnished/dirty artifact to reveal its true appearance. */
export const rubInteraction: Interaction = {
  id: "rub",
  label: "Rub",
  canExecute: (ctx) => artifactOf(ctx) !== undefined,
  execute: async (ctx) => {
    if (ctx.entity) {
      if (!artifactOf(ctx)) return { success: false, message: "Nothing to rub." };
      ctx.commands.execute(new RubArtifactCommand(ctx.entity.id));
      return { success: true };
    }
    if (ctx.inventoryItem) {
      if (!artifactOf(ctx)) return { success: false, message: "Nothing to rub." };
      ctx.commands.execute(new RubArtifactCommand(ctx.inventoryItem.instanceId));
      return { success: true };
    }
    return { success: false, message: "Nothing to rub." };
  },
};
